import React, { useState, Fragment, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import BankInformationSchema from "./ValidationSchema/BankInformationSchema";
import API_Call from "../../Util/API Calls/afterLogin";
import Loader from "../UI Component/Loader/Loader";
import swal from "sweetalert";

const BankInformation = (props) => {
  const [state, setState] = useState({
    submitBankInformation: false,
    loading: false,
  });

  const [accountNumberType, setAccountNumberType] = useState(false);

  const Bank_Information_fields_Initial_Value = {
    bank_account_name: props.isFilled.submitBankInformation
      ? props.isFilled.bank_account_name
      : "",
    bank_ifsc_code: props.isFilled.submitBankInformation
      ? props.isFilled.bank_ifsc_code
      : "",
    bank_account_number: props.isFilled.submitBankInformation
      ? props.isFilled.bank_account_number
      : "",
    bank_account_number_confirm: props.isFilled.submitBankInformation
      ? props.isFilled.bank_account_number_confirm
      : "",
    gst_number: props.isFilled.submitBankInformation
      ? props.isFilled.gst_number
      : "",
  };

  useEffect(() => {
    let confirmAccountField = document.getElementById("confirmAccountNumber");
    confirmAccountField.onpaste = function (e) {
      e.preventDefault();
    };
    let bankAccountNumber = document.getElementById("bank_account_number");
    if (
      props.isFilled.submitBankInformation &&
      props.isFilled.bank_account_number
    ) {
      setAccountNumberType(true);
    }
    bankAccountNumber.onblur = function (e) {
      setAccountNumberType(true);
    };
    bankAccountNumber.onfocus = function (e) {
      setAccountNumberType(false);
    };
  }, []);

  const gstHandler = (handleChange, selectedOption) => {
    selectedOption.target.value = selectedOption.target.value.toUpperCase();
    handleChange(selectedOption);
  };

  const submitHandler = async (allValues, { setSubmitting, resetForm }) => {
    const values = BankInformationSchema.cast(allValues);
    setSubmitting(true);
    setState({ ...values, loading: true });
    API_Call.post("/public/create-doctor-onboard-application", {
      step: "2",
      doctor_application_id: localStorage.getItem("doctor_application_id"),
      ...values,
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.statusCode === 200) {
            setState({
              ...state,
              ...values,
              submitBankInformation: true,
              loading: false,
            });

            const Msg = swal({
              title: "Data Saved Successfully",
              // text: response.data.message,
              icon: "success",
              button: "OK",
            }).then(() => {
              props.submitData({
                ...values,
                ...state,
                submitBankInformation: true,
              });
            });
            return Msg;
          } else {
            setState({ ...state, loading: false });
            const Msg = swal({
              title: "Invalid Submission",
              text: response.data.message
                ? response.data.message
                : response.data.errorMessage,
              icon: "warning",
              button: "OK",
            });
            return Msg;
          }
        } else {
          setState({ ...state, loading: false });
          const Msg = swal({
            title: "Server Error",
            text: "Something went wrong",
            icon: "danger",
            button: "OK",
          });
          return Msg;
        }
      })
      .catch((err) => {
        setState({ ...state, loading: false });
        const Msg = swal({
          title: "Server Error",
          text: err,
          icon: "danger",
          button: "OK",
        });
        return Msg;
      });
  };

  const renderErrors = (errors, touched) => {
    let errorsToRender = [];
    for (let error in errors) {
      if (touched[error] && error !== "status" && error !== "is_agreed") {
        let errorToRender = errors[error];
        errorToRender = errorToRender[0].toUpperCase() + errorToRender.slice(1);
        errorsToRender.push(errorToRender);
      }
    }
    if (errorsToRender.length > 1)
      return (
        <div className={"invalid-feedback d-block"}>
          Please fill all the mandatory fields
        </div>
      );
    return errorsToRender.map((error) => (
      <div className={"invalid-feedback d-block"}>{error}</div>
    ));
  };

  return (
    <Fragment>
      {state.loading ? <Loader /> : null}

      <section
        id="side_tab2"
        className="item active"
        data-title="Bank Information"
      >
        <div className="item-content">
          <div className="personal-info">
            <div className="info-ttl">
              <h2>Bank Information</h2>
            </div>
            <div className="info-form">
              <Formik
                onSubmit={submitHandler}
                initialValues={Bank_Information_fields_Initial_Value}
                validationSchema={BankInformationSchema}
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  handleBlur,
                  onFocus,
                  errors,
                  touched,
                  isSubmitting,
                  setValues,
                  setFieldValue,
                }) => (
                  <form noValidate onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-8 col-sm-6">
                        <div className="form-group">
                          <label>
                            Account Number <span>*</span>
                          </label>
                          <Form.Control
                            required
                            type={
                              accountNumberType == true ? "password" : "text"
                            }
                            className="cstom-control"
                            placeholder="Account Number"
                            id="bank_account_number"
                            name={"bank_account_number"}
                            value={values.bank_account_number}
                            isInvalid={
                              errors.bank_account_number &&
                              touched.bank_account_number
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.bank_account_number}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-8 col-sm-6">
                        <div className="form-group">
                          <label>
                            Re-enter Account Number <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            required
                            id="confirmAccountNumber"
                            autoComplete="off"
                            className="cstom-control"
                            placeholder="Confirm Bank Account Number"
                            name={"bank_account_number_confirm"}
                            value={values.bank_account_number_confirm}
                            isInvalid={
                              errors.bank_account_number_confirm &&
                              touched.bank_account_number_confirm
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.bank_account_number_confirm}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="form-group">
                          <label>
                            Bank Name <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            required
                            className="cstom-control"
                            placeholder="Bank Name"
                            name={"bank_account_name"}
                            value={values.bank_account_name}
                            isInvalid={
                              errors.bank_account_name &&
                              touched.bank_account_name
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.bank_account_name}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="form-group">
                          <label>
                            IFSC Code <span>*</span>
                          </label>
                          <Form.Control
                            type="text"
                            required
                            className="cstom-control"
                            placeholder="IFSC Code"
                            name={"bank_ifsc_code"}
                            value={values.bank_ifsc_code}
                            isInvalid={
                              errors.bank_ifsc_code && touched.bank_ifsc_code
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.bank_ifsc_code}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="col-lg-6 col-sm-6">
                        <div className="form-group">
                          <label>GSTIN (Optional)</label>
                          <Form.Control
                            type="text"
                            className="cstom-control"
                            placeholder="GSTIN"
                            onChange={(selected) =>
                              gstHandler(handleChange, selected)
                            }
                            name={"gst_number"}
                            value={values.gst_number}
                            isInvalid={errors.gst_number && touched.gst_number}
                            onBlur={handleBlur}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.gst_number}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className="save-next d-flex">
                      <button
                        type="button"
                        className="custom-bck"
                        onClick={() =>
                          props.previousTab("Personal Information")
                        }
                      >
                        <i className="fa fa-angle-left"></i> Back{" "}
                      </button>
                      <button
                        type="submit"
                        className="custom-btnn"
                        disabled={isSubmitting}
                      >
                        Save & Proceed <i className="fa fa-angle-right"></i>
                      </button>
                    </div>
                    <div className={"d-flex mt-3"}>
                      <div className="ml-auto">
                        {renderErrors(errors, touched)}
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default BankInformation;
